// extracted by mini-css-extract-plugin
export var aotyEmblem = "styles-module__aotyEmblem___iYdVA";
export var aotyText = "styles-module__aotyText___s6HIr";
export var appScreenVariant = "styles-module__appScreenVariant___i41u5";
export var appleVideoVariant = "styles-module__appleVideoVariant___L7T1P";
export var button = "styles-module__button___M99Bs";
export var close = "styles-module__close___uf0Ax";
export var container = "styles-module__container___tmd7I";
export var contentContainer = "styles-module__contentContainer___TX2gS";
export var divider = "styles-module__divider___pWEbb";
export var header = "styles-module__header___BKLB7";
export var imageContainer = "styles-module__imageContainer___svl7i";
export var logoAndRatingContainer = "styles-module__logoAndRatingContainer___ZBmGD";
export var nameAndRatingContainer = "styles-module__nameAndRatingContainer___leC59";
export var phone = "styles-module__phone___vgtf1";
export var ratingContainer = "styles-module__ratingContainer___rUWSw";
export var texture = "styles-module__texture___QbAId";
export var variantBg = "styles-module__variantBg___S3hCM";
export var variantContainer = "styles-module__variantContainer___PPzHz";
export var variantHeader = "styles-module__variantHeader___w7nj6";
export var variantHeaderContainer = "styles-module__variantHeaderContainer___f1igJ";
export var variantPhone = "styles-module__variantPhone___hVzUh";
export var variantPhoneContainer = "styles-module__variantPhoneContainer___YQ4yR";
export var white = "styles-module__white___Jn9_g";